<template>
  <DModal :show-close="false">
    <div class="d-modal" slot="insertComponent">
      <div class="d-modal__header">
        <h2>{{ $t('vue2.sms.do_you_want_to_delete_the_template') }}?</h2>
      </div>
      <div class="d-modal__content">
        <h4>{{ editsms.title }}</h4>
        <p class="marg-1-bottom"><i>{{ editsms.body }}</i></p>
      </div>
      <div class="d-modal__buttons pad-1">
        <button class="bttn marg-10-right" @click="$emit('close')">{{ $t('vue2.common.cancel') }}</button>
        <button class="bttn bttn-danger" @click="submit">{{ $t('vue2.common.delete') }}</button>
      </div>
    </div>
  </DModal>
</template>

<script>
import docendo from '../../docendo'
import DModal from '../common/DModal'
import eventbus from '../../eventbus'

export default {
  components: {DModal},
  props: {
    editsms: {
      type: Object
    },
    messageType: {
      default: 'sms'
    }
  },
  methods: {
    submit () {
      docendo.deleteMessageTemplate(window.SCHOOL.id, this.editsms.id, success => {
        eventbus.toast = {text: this.$t('vue2.sms.template_sms_deleted'), success: true}
        this.$emit('updated')
      }, failure => {
        eventbus.toast = {text: this.$t('vue2.sms.an_error_occured'), success: false}
        this.$emit('close')
      })
    }
  }
}
</script>

<style>
.d-modal {
  width: 350px;
  border-radius: 16px;
  position: relative;
}

.d-modal__header {
  margin-bottom: 10px;
}

.d-modal__close {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 16px !important;
}

.d-modal__buttons {
  margin: 10px 0;
  display: flex;
  justify-content: flex-end;
}

.d-modal__content {
  padding: 1rem;
}

</style>



// WEBPACK FOOTER //
// MedssageTemplateDelete.vue?79d9204f